export default __webpack_public_path__ + "static/media/tooth_for_mouth_small.278bc826.png";